export const styles = {
  modalBody: {
    minWidth: 480,
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  sectionTitle: {
    display: 'block',
    fontWeight: 700,
    fontSize: 15,
    color: '#1e293b',
    marginBottom: 4,
    marginTop: 4,
    paddingBottom: 6,
    borderBottom: '1px solid #f1f5f9',
  },
  sectionHelper: {
    fontSize: 12,
    color: '#888',
    marginTop: 4,
  },
  toggleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  toggleLabel: {
    fontSize: 13,
    color: '#333',
  },
  previewBox: {
    fontSize: 13,
    color: '#1565c0',
    width: '100%',
    backgroundColor: '#e8f4fd',
    borderRadius: 8,
    padding: '8px 12px',
    marginBottom: 4,
    marginTop: 4,
  },
};
